module.exports = require("katex");


//////////////////
// WEBPACK FOOTER
// external "katex"
// module id = 3
// module chunks = 0